import React from 'react';

interface SkeletonProps {
  /** How many bars. The last one is shorter, like the end of a paragraph. */
  lines?: number;
  /** Read out in place of the bars. */
  label?: string;
  className?: string;
}

/**
 * A grey placeholder while content loads (item 72). It stands where the content will be, so the page
 * does not jump when it arrives. The bars are decorative; the label is what a screen reader hears.
 * It never stands in for a figure: a number that has not loaded is "Loading…", not a bar.
 */
const Skeleton: React.FC<SkeletonProps> = ({ lines = 3, label = 'Loading…', className = '' }) => (
  <div className={`ui-skeleton ${className}`.trim()} role="status">
    <span className="sr-only">{label}</span>
    {Array.from({ length: lines }, (_, i) => (
      <span key={i} className={`ui-skeleton-bar${i === lines - 1 && lines > 1 ? ' is-last' : ''}`} aria-hidden />
    ))}
  </div>
);

export default Skeleton;
